enum HowItWorksBuilderControlName {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  CompanyName = 'companyName',
  Locations = 'locations',
  Phone = 'phone',
}

export default HowItWorksBuilderControlName;
